import styles from './index.module.less'

import ChatItem from '@/pages/messageChat/ChatItem'
import { Scrollbars } from 'react-custom-scrollbars'
import { useEffect, useRef } from 'react'
import { useSetState } from 'ahooks'
import { isNil } from 'lodash-es'

export default function ChatList(props) {
  const { data, slot, active, onSelect, defaultHeight, urlPrefix, countDict, hideBadge } = props
  const scroller = useRef<any>()
  const [state, setState] = useSetState({
    scrollerHeight: '',
  })

  useEffect(() => {
    setTimeout(() => {
      const rect = scroller.current.getBoundingClientRect()
      console.log('rect', rect)
      setState({
        scrollerHeight: `calc(100vh - ${rect.top + 24}px)`,
      })
    }, 10)
  }, [])

  return (
    <div className={styles.chartList}>
      {slot?.header}
      <Scrollbars
        autoHide
        renderTrackHorizontal={() => <div></div>}
        style={{ height: state.scrollerHeight || defaultHeight || 'calc(100vh - 120px)' }}
        // style={{ height: '100vh' }}
      >
        <div className={styles.scroller} ref={scroller}>
          {data?.map?.((d, i) => {
            const opts = {
              urlPrefix,
              active: `${active?.id}` === `${d.id}`,
              onClick: () => onSelect?.(d),
              unReadCount: isNil(countDict[d?.id]) ? d.unReadCount : countDict[d?.id],
              hideBadge,
            }
            return (
              slot?.renderItem?.(d, i, opts) || (
                <ChatItem key={`chat_item_${i}`} data={d} {...opts} />
              )
            )
          })}
        </div>
      </Scrollbars>
    </div>
  )
}
